import React from "react";
import { Wind } from "lucide-react";

/**
 * Insight panel describing the typical scale of deployment proposed across
 * the 22 workshops. Not a chart — a clean, readable statement of pattern.
 */
export default function DeploymentScalePanel() {
  return (
    <section data-testid="deployment-scale-panel">
      <div className="mb-4">
        <h2 className="text-xl font-semibold tracking-tight text-gray-900">
          Typical deployment scale
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          What a "community-designed" deployment tends to look like in the
          South Downs region.
        </p>
      </div>
      <div className="bg-white border border-gray-200 p-6 grid md:grid-cols-[auto_1fr] gap-5 items-start">
        <div className="h-12 w-12 border border-[#2F4F4F] bg-[#2F4F4F] text-white flex items-center justify-center flex-shrink-0">
          <Wind className="h-5 w-5" />
        </div>
        <div>
          <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2">
            <div>
              <div className="text-[11px] uppercase tracking-wider text-gray-500">
                Most common range
              </div>
              <div className="text-3xl font-bold font-mono text-gray-900 mt-1">
                1 – 6
                <span className="text-base font-medium text-gray-500 ml-2">
                  turbines per workshop
                </span>
              </div>
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-wider text-gray-500">
                Configuration bias
              </div>
              <div className="text-sm text-gray-800 mt-1">
                Fewer, larger turbines · clustered in one area
              </div>
            </div>
          </div>
          <p className="text-sm text-gray-700 mt-3 leading-relaxed max-w-2xl">
            Workshops typically converge on a small cluster of 1–6 turbines.
            At this scale, communities note that onshore wind is often
            sufficient to meet a significant share of local electricity demand
            — without requiring landscape-dominant deployments.
          </p>
        </div>
      </div>
    </section>
  );
}
